// this file is generated by update_shopify_store_data.py at 2026-01-26 20:20:26.852478
var courses = [
    {
        "course_id": "C783B6BB-581F-EF11-998F-005056A7AAEE",
        "course_version": 1,
        "name": "AWHONN POEP24 \u2013 Resource - Participant Manual",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The Participant Manual is a guide to instruct participants on how to use the POEP24 program.",
        "learning_objectives_html": "At the completion the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Utilize the Participant Manual as a guide on how to use the POEP24 program</li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A0133CD9-BD21-EF11-999E-005056A7C6AF",
                "course_category_name": "AWHONN - POEP24 Resources Only (No Self-Enroll) (Modules available in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "9A217A5A-1619-EF11-998F-005056A721AC",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 01: Foundations",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of the principles of patient safety, risk management, perinatal liability, and respectful maternity care.",
        "learning_objectives_html": "At the completion of Module 1 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Analyze strategies to address harm associated with disparities in the perinatal setting.&nbsp;&nbsp;</li>\r\n    <li>Formulate risk management and risk reduction strategies.&nbsp;&nbsp;</li>\r\n    <li>Identify sources of perinatal liability and risk.&nbsp;&nbsp;</li>\r\n    <li>Identify essential aspects of respectful care in perinatal settings.&nbsp;&nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "615CD234-4719-EF11-9993-005056A7E0DF",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 02: Reproductive Overview and Adaptation to Pregnancy",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to review the reproductive system, issues with fertility, embryonic and fetal development, physiologic changes and psychosocial adaptation, and prenatal assessment and screenings.",
        "learning_objectives_html": "At the completion of Module 2 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Discuss the physical and hormonal influences of the female reproductive system.&nbsp;</li>\r\n    <li>Discuss the definition and prevalence of infertility.&nbsp;</li>\r\n    <li>Identify factors that can influence conception and adaptation to pregnancy.&nbsp;&nbsp;</li>\r\n    <li>Determine the screenings and assessments that may occur during pregnancy.&nbsp;&nbsp;</li>\r\n</ul>\r\n<div>Please note:&nbsp;The CDC's Intimate Partner Violence page (which is listed in the Resources tab) has moved. It is now <a href=\"https://www.cdc.gov/intimate-partner-violence/about/\">here.</a>\r\n</div>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "0DF4844A-4819-EF11-9993-005056A7E0DF",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 03: Process of Labor and Birth",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to describe the factors affecting labor, labor and fetal assessments, stages of labor, and labor support.",
        "learning_objectives_html": "At the completion of Module 3 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Discuss the factors and conditions that may affect the process and outcomes of labor.&nbsp;</li>\r\n    <li>Analyze the nursing care and interventions provided during each stage of labor.&nbsp;</li>\r\n    <li>Identify techniques to support the patient with coping during labor.&nbsp;&nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "42C3919A-4A19-EF11-9993-005056A7E0DF",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 04: Complications With Labor and Birth",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of the potential complications with labor and birth.",
        "learning_objectives_html": "At the completion of Module 4 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Formulate the plan of care for induction and augmentation of labor.&nbsp;</li>\r\n    <li>Articulate methods to promote vaginal birth.&nbsp;</li>\r\n    <li>Discuss the nursing care of the patient with abnormal labor patterns.&nbsp;</li>\r\n    <li>Prioritize the appropriate steps in the care of a patient with obstetric complications.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "A8CCB2A0-4D19-EF11-9993-005056A7E0DF",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 05: Cesarean Birth and Post-Anesthesia Care",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of cesarean birth, review the concepts of anesthesia, supply a summary of preoperative, intraoperative care and enhanced recovery after surgery in obstetrics, examine the principles of sterile techniques and infection prevention, and give an outline of post anesthesia care (routine and complications) for patients after a cesarean birth.",
        "learning_objectives_html": "At the completion of Module 5 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Analyze conditions requiring cesarean birth.&nbsp;&nbsp;</li>\r\n    <li>Describe the nursing care provided for a cesarean birth in the preoperative, intraoperative, and postoperative periods.&nbsp;&nbsp;</li>\r\n    <li>Recognize potential complications that may arise during various periods of care for a cesarean birth.&nbsp;&nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "D89A4D0B-BF1D-EF11-9990-005056A77B46",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 06: Perinatal Infections",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of sexually transmitted infections and perinatal infections that can occur during pregnancy, as well as the related newborn outcomes that result if these infections are left untreated.",
        "learning_objectives_html": "At the completion of Module 6 the learner will be able to:\r\n<ul>\r\n    <li>Explain common sexually transmitted infections, symptoms, and treatment during pregnancy.</li>\r\n    <li>Identify nursing interventions for common perinatal infections.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "2D04EB77-C11D-EF11-9990-005056A77B46",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 07: Antepartum Complications",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of potential antepartum complications, including preterm labor and birth, multiple gestation, bleeding, hypertensive disorders, and trauma.",
        "learning_objectives_html": "At the completion of Module 7 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Explain the risk factors associated with antepartum complications.&nbsp;</li>\r\n    <li>Distinguish the interventions in the care of patients with various antepartum complications.</li>\r\n    <li>Formulate the nursing plan of care for a patient with antepartum complications.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 5.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "AD6C7643-C21D-EF11-9990-005056A77B46",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 08: System Related Complications of Pregnancy",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of potential system related complications of pregnancy including, cardiac disease, hematologic, respiratory, endocrine, gastrointestinal and hepatic disorders.",
        "learning_objectives_html": "At the completion of Module 8 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Identify signs and symptoms for those affected by system-related pregnancy complications.&nbsp;</li>\r\n    <li>Discuss medical management and nursing care for system-related pregnancy complications.&nbsp;</li>\r\n    <li>Summarize maternal and fetal implications arising from system-related pregnancy complications.&nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "3A30F64C-C51D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 09: Postpartum Assessment and Care",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to review the postpartum physiology, the postpartum assessment and care of a patient who had a vaginal birth, the postpartum assessment and care of a patient who had a cesarean birth, the adaptation to parenthood, and the discharge process.",
        "learning_objectives_html": "At the completion of Module 9 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Describe the physiologic changes occurring during the postpartum period.</li>\r\n    <li>Identify nursing assessment and care for the postpartum patient.</li>\r\n    <li>Analyze the principles related to discharge and discharge teaching.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "FBF5CA1C-C61D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 10: Postpartum Complications",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of postpartum complications such as postpartum hemorrhage, disseminated intravascular coagulopathy (DIC), postpartum infections, thromboembolic disorders, genital tract/pelvic floor concerns, hypertensive disorders in the postpartum period and postpartum mood and anxiety disorders.",
        "learning_objectives_html": "At the completion of Module 10 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Describe abnormal physiologic changes that occur during the postpartum period.</li>\r\n    <li>Differentiate normal from abnormal assessment findings in the postpartum period.</li>\r\n    <li>Identify causes, signs and symptoms, and management of possible complications in the postpartum period.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "666582F9-C61D-EF11-9990-005056A77B46",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 11: Newborn Transition",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of preparing for birth, newborn transition to extrauterine life, thermoregulation, and transitional complications.",
        "learning_objectives_html": "At the completion of Module 11 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Identify physiologic changes that occur during that transition from fetal to extrauterine life.</li>\r\n    <li>Describe the process of immediate newborn assessment and stabilization.</li>\r\n    <li>Analyze risk factors for transition-related complications in the newborn.<br />\r\n    <div>&nbsp;</div>\r\n    &nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "BBF1987C-CA1D-EF11-9990-005056A77B46",
        "course_version": 3,
        "name": "AWHONN POEP24 - Module 12: Newborn Assessment, Routine Care, and Discharge",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of newborn assessment, routine newborn care, and newborn discharge.",
        "learning_objectives_html": "At the completion of Module 12 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Describe a comprehensive newborn physical assessment using a systematic approach, identifying deviations from normal.</li>\r\n    <li>Identify routine care for a newborn, including discharge criteria and parent education.</li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "0D0D8B4B-CB1D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 13: Newborn Nutrition",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of breastfeeding, review milk expression information, discuss breastfeeding challenges, breastfeeding assessment, and discuss supplementation.",
        "learning_objectives_html": "At the completion of Module 13 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Describe the physiology of lactation and measures necessary for the initiation and maintenance of milk supply.&nbsp;</li>\r\n    <li>Identify nursing interventions to encourage and support breastfeeding.&nbsp;</li>\r\n    <li>Recognize indications for supplementation or formula feeding and provide support.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "11D34B8F-CC1D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 14: Newborn Clinical Deterioration",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of newborn clinical deterioration including respiratory disorders, congenital heart defects, and sepsis.",
        "learning_objectives_html": "At the completion of Module 14 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Identify a newborn&rsquo;s potential risk factors for clinical deterioration.&nbsp;</li>\r\n    <li>Recognize and respond to newborn clinical deterioration.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "7891256D-CD1D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 15: Newborn Conditions Affecting Care and Outcomes",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of growth and maturational issues, newborn hypoglycemia, hyperbilirubinemia, and newborns with substance exposure.",
        "learning_objectives_html": "At the completion of Module 15 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Recognize risk factors for conditions that affect care and outcomes.</li>\r\n    <li>Identify appropriate nursing assessments and interventions to provide specialized care to high-risk newborns.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "D314B442-CE1D-EF11-9990-005056A77B46",
        "course_version": 2,
        "name": "AWHONN POEP24 - Module 16: Perinatal Loss",
        "course_type": 1,
        "author_information": "The Perinatal Orientation and Education Program (POEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "The purpose of this module is to provide an overview of perinatal nursing and loss, discuss the meaning of bereavement, grief, and mourning, examine the cultural and spiritual aspects of loss, assess parental grief, support the care of bereaved families, and provide strategies for caring for the caregiver.",
        "learning_objectives_html": "At the completion of Module 16 the learner will be able to:\r\n<ul style=\"list-style-type: disc;\">\r\n    <li>Distinguish between types of perinatal loss and frequency of occurrence.</li>\r\n    <li>Recognize the need for individualized care in caring for patients and their families.</li>\r\n    <li>Describe the impact of perinatal loss on patients, families, and staff.&nbsp;</li>\r\n    <li>Articulate strategies for caring, teaching, and helping families cope with perinatal loss.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "B1716043-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN - AWHONN POEP24 Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53115C25-1719-EF11-998F-005056A721AC",
                "course_category_name": "AWHONN POEP24 Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];